const getStudentTagFilter = response => {
  const formattedData = response.data.map(entry => ({
    id: entry.id,
    name: entry.name,
  }));
  const searchable = formattedData.length > 10;

  return {
    key: 'studentTag',
    source: 'studentTag',
    filterName: 'Student Tags',
    searchable,
    defaultSelection: formattedData,
    options: formattedData,
    selector: 'id',
    label: 'name',
  };
};

export default getStudentTagFilter;
